<template>
  <div class="mit-my-borrowed-list pa-5">
    <BaseMitLoading :show="loading" :overlayFullscreen="false"/>
    <BaseMitDataTable
      title="Borrowed"
      :editable="false"
      :headers="headers"
      :items="borrowed"
    >
    </BaseMitDataTable>
  </div>
</template>

<script>
import BaseMitKeysApiService from '../../services/BaseMitKeysApiService.js';
import BaseMitDataTable from '../../components/BaseMitDataTable.vue';
import BaseMitLoading from '../../components/BaseMitLoading.vue';

export default {
  name: 'BaseMitMyBorrowedList',
  components: {
    BaseMitLoading,
    BaseMitDataTable
  },
  props: {
  },
  data: function() {
    return {
      loading:false,
      search: '',
      headers:[
          {text: 'Key',sortable: true,value: 'keyName',},
          // temporary hiding spaces
          // {text: 'Spaces',sortable: false,value: 'accessSpacesDisplay',},
          {text: 'Borrowed Date',sortable: true,value: 'dates_local.checkoutDt',}
        ],
      borrowed:[],
      keysService: null
    }
  },
  mounted() {
    this.keysService = new BaseMitKeysApiService();
    this.loading = true;
    this.keysService.getMyKeys()
      .then((keys) => {
        this.loading = false;
        this.borrowed = keys;
      })
      .catch((error) => {
        this.loading = false;
        console.log('An error occurred trying to get keys list', error);
      });
  },
  methods : {
  }
}
</script>

<style lang="scss" scoped>
</style>
